import React from "react";
import HomepageBrandValue, {
    HomepageBrandValueProps,
} from "web/react/components/homepage-brand-value/homepage-brand-value";
import TopProducts, { TopProductsProps } from "web/react/components/top-products/top-products";

interface HomepageLayoutProps {
    layoutData: {
        homepage_popular_products: TopProductsProps;
        homepage_brand_values: HomepageBrandValueProps;
    };
}

export function HomepageLayout({
    layoutData: { homepage_popular_products: popularProducts, homepage_brand_values: brandValues },
}: HomepageLayoutProps): JSX.Element {
    return (
        <>
            <TopProducts products={popularProducts.products} />
            {brandValues && <HomepageBrandValue {...brandValues} />}
        </>
    );
}

export default HomepageLayout;
